import axios from 'axios';

export function getProject(projectUserId) {
  return axios.get(`/project/${projectUserId}`);
}

export function getProjects() {
  return axios.get('/projects');
}

export function getProjectUser(projectUserId) {
  return axios.get(`project/${projectUserId}/user`);
}

export function updateDueDates(projectUserId, payload) {
  return axios.post(`project/${projectUserId}/update-due-dates`, payload);
}

export function toggleArea(projectUserId, areaId) {
  return axios.put(`project/${projectUserId}/area/${areaId}`);
}

export function toggleAreaPhase(projectUserId, areaId, phaseId) {
  return axios.put(`project/${projectUserId}/area/${areaId}/phase/${phaseId}`);
}

export function getProjectOverview(projectUserId) {
  return axios.get(`/project/${projectUserId}/overview`);
}

export function getProjectWarnings(projectUserId) {
  return axios.get(`/project/${projectUserId}/warnings`);
}

export function acceptContract(projectUserId) {
  return axios.put(`/project/${projectUserId}/contract`, { hasAccepted: true });
}

export function getFile(path) {
  return axios.get(path, { responseType: 'blob' });
}

export function getContractExists(projectUserId) {
  return axios.get(`/project/${projectUserId}/contract/exists`);
}

export function stop(projectUserId) {
  return axios.post(`/stop/${projectUserId}`);
}

export function accept(projectUserId) {
  return axios.post(`/accept/${projectUserId}`);
}

export function end(projectUserId) {
  return axios.post(`/end/${projectUserId}`);
}

export function decline(projectUserId) {
  return axios.post(`/decline/${projectUserId}`);
}

export function getStep1(config) {
  return axios.get('/new/step1', config);
}

export function save(payload) {
  return axios.post('/new/save', payload);
}

export function getPickTeamLead(projectUserId) {
  return axios.get(`/pick-manager/${projectUserId}`);
}

export function assignTeamLead(payload) {
  return axios.post('/assign-manager', payload);
}